import React from 'react';
import authService from '../services/authService';

const ProtectedRoute = ({ children, isAuthenticated, onLogout }) => {
  // Double-check authentication status
  const isAuth = isAuthenticated && authService.isAuthenticated();
  
  if (!isAuth) {
    // If not authenticated, the parent component should handle showing login
    return null;
  }

  return (
    <div>
      {/* Session info bar (optional) */}
      <div className="bg-blue-50 border-b border-blue-200 px-4 py-2">
        <div className="max-w-7xl mx-auto flex justify-between items-center text-sm">
          <span className="text-blue-700">
            Session active - {authService.getRemainingSessionTime()} minutes remaining
          </span>
          <button
            onClick={onLogout}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            Logout
          </button>
        </div>
      </div>
      
      {/* Protected content */}
      {children}
    </div>
  );
};

export default ProtectedRoute;